import {State} from '../../Store';
import {Store} from 'vuex';
import {
	EditorClipboardMutation,
	EditorClipboardState,
	EditorClipboardPayloadByMutationMap,
} from '../../modules/editor/Clipboard';
import {CoreGraphNodeId} from '../../../../../@polygonjs/polygonjs/src/core/graph/CoreGraph';

export class EditorClipboardStoreControllerClass {
	private _store!: Store<State>;

	private static _instance: EditorClipboardStoreControllerClass;
	static instance() {
		return (this._instance = this._instance || new EditorClipboardStoreControllerClass());
	}

	private constructor() {}

	set_store(store: Store<State>) {
		this._store = store;
	}

	// getters
	get local_state(): EditorClipboardState {
		return (<unknown>(this._store.state.editor as any).clipboard) as EditorClipboardState;
	}
	node_id(): CoreGraphNodeId | null {
		return this.local_state.node_id;
	}
	param_id(): CoreGraphNodeId | null {
		return this.local_state.param_id;
	}
	upload_name(): string | null {
		return this.local_state.upload_name;
	}
	// upload_name(): string | null {
	// 	return this.local_state.upload_name;
	// }

	// mutations
	set_node_id(node_id: EditorClipboardPayloadByMutationMap[EditorClipboardMutation.NODE_ID]): void {
		this._store.commit(`editor/clipboard/${EditorClipboardMutation.NODE_ID}`, node_id);
	}
	set_param_id(param_id: EditorClipboardPayloadByMutationMap[EditorClipboardMutation.PARAM_ID]): void {
		this._store.commit(`editor/clipboard/${EditorClipboardMutation.PARAM_ID}`, param_id);
	}
	set_upload_name(upload_name: EditorClipboardPayloadByMutationMap[EditorClipboardMutation.UPLOAD_NAME]): void {
		this._store.commit(`editor/clipboard/${EditorClipboardMutation.UPLOAD_NAME}`, upload_name);
	}
	// set_upload_name(name: string): void {
	// 	this._store.commit(`editor/context_menu/${EditorClipboardMutation.UPLOAD_NAME}`, name);
	// }
}

export const EditorClipboardStoreController = EditorClipboardStoreControllerClass.instance();
